<template>
  <div id="PrePaTrack">

    <!-- PRE PA Track CARD -->
    <v-card v-if="school.preprofessional_degree_required" outlined>
      <v-layout row align-center justify-center class="grey lighten-4 pb-2 mx-0"> 
        <span class="title font-weight-regular  align-center mt-1">Pre-PA Curriculum</span>
      </v-layout>
      <v-container  pb-1>
        <v-layout column>
          
          <v-layout justify-center mt-4 pb-3>
            <span class="font-weight-light title grey--text">Info Coming Soon</span>
          </v-layout>


        </v-layout>
      </v-container>
    </v-card>

  </div>
</template>


<script>
  
  export default {
    props: ['school'],
    data() {
      return  {
        showPaClubInfo: false,
      }
    }
  }
</script>

<style scoped>



 .card {
    border-radius: 10px;
  }
     #buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}

.link {
  text-decoration: none;
}
img {
  width:30px;
  height:30px;
}

.linkLogo {
  width:33px;
  height:33px;
  margin-left:10px;
  margin-right: 10px;
  border-radius:5px;
}

.tweetLogo {
  width:37px;
  height:37px;
  margin-left:10px;
  margin-right: 10px;
  border-radius:10px;
}
.blueHeading {
  color:#2196F3;
}

.background {
  background-color: rgb(255, 255, 255);
}

 
</style>


// WEBPACK FOOTER //
// src/components/Schools/SchoolDetail/PrePaTrack.vue